import { render, staticRenderFns } from "./promotionCell.vue?vue&type=template&id=23ef865e&scoped=true"
import script from "./promotionCell.vue?vue&type=script&lang=js"
export * from "./promotionCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ef865e",
  null
  
)

export default component.exports